export default "__VITE_ASSET__BU7z_gks__"